<template>
  <div class="row">
    <div
      v-for="e in menuUmkm"
      :key="e.id_menu_umkm"
      class="col-md-3"
    >
      <div class="card">
        <img v-if="!e.foto" class="card-img-top" :src="require('./../../assets/stisla/img/news/img01.jpg')"
        alt="Card image cap">
        <img v-else class="card-img-top" :src="$store.getters.getBaseUrl + '/api/file/' + e.foto"
        alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">{{ e.nama_menu }}</h5>
          <p class="card-text text-right">
            Rp {{ e.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </p>
          <p class="text-right">
            <button
              v-if="pesanan && !pesanan.det_pesanan.find(f => f.id_menu_umkm === e.id_menu_umkm) && (namaRole === 'Penduduk' || namaRole === 'Operator Desa')"
              class="btn btn-primary m-1"
              @click="pilih(e)"
            >
              <i class="fa fa-check" />
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  props: {
    pesanan: { // untuk tombol pilih menu, kalau sudah ada di pesanan gak bisa
      type: Object,
      default: () => null
    },
    tanggalAmbil: {
      type: String,
      default: () => null
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  data() {
    return {
      menuUmkm: []
    }
  },
  mounted () {
    this.loadMenuUmkmReady()
  },
  methods: {
    loadMenuUmkmReady() {
      this.$store.dispatch('fetchMenuUmkmReady').then((res) => {
        if (res.data.status) {
          this.menuUmkm = res.data.data
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })
    },
    pilih (row) {
      const formData = new FormData()
      formData.append('id_data_permohonan', this.$store.getters.getDataPermohonan.id_data_permohonan)
      formData.append('id_menu_umkm', row.id_menu_umkm)
      this.$store.dispatch('storePesanan', formData).then((res) => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.$emit('loadPesanan')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })
    }
  }
}
</script>